import { Injectable } from '@angular/core';

import {
  CtdUnpaidModalComponent,
  ICtdUnpaidModalComponent
} from 'src/app/modals/pos-manager/ctd-unpaid-modal/ctd-unpaid-modal.component';
import { ModalService } from 'src/app/services';

@Injectable()
export class CtdUnpaidModalService {
  constructor(private readonly modalService: ModalService) {}

  showModal(
    props: ICtdUnpaidModalComponent,
    position: 'start' | 'center' | 'end' = 'start', // Start: top, center: middle, end: bottom
    dismissHandler?: (footerIdxBtnClick: number) => void
  ) {
    this.modalService.showModal<number, ICtdUnpaidModalComponent>(
      CtdUnpaidModalComponent,
      props,
      {
        cssClass: [
          'dynamic-height-modal',
          'small-modal',
          'custom-flex-col',
          `ion-justify-content-${position}`
        ],
        backdropDismiss: false,
        animated: true
      },
      ({ data }) => dismissHandler && dismissHandler(data) // Call the dismiss handler if provided
    );
  }
}
